"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmbedData = getEmbedData;
exports.getEmbedType = getEmbedType;
exports.defaultValidateEmbed = defaultValidateEmbed;
exports.generateIframeEmbed = generateIframeEmbed;
exports.convertUrlToEmbedData = exports.matchesWhitelistedEmbedUrl = exports.guessMime = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _embed = require("../constants/embed");

var _htmlToEmbedData = _interopRequireDefault(require("../utils/htmlToEmbedData"));

var guessMime = function guessMime(url) {
  if (!url) {
    return '';
  }

  url = url.toLowerCase();
  var match = Object.keys(_embed.supportedMimeTypes).find(function (key) {
    return url.indexOf("." + key) !== -1;
  });
  return match ? _embed.supportedMimeTypes[match] : '';
};

exports.guessMime = guessMime;

function getEmbedData(modalData) {
  if (!modalData) {
    return null;
  }

  if (modalData.url) {
    return getEmbedDataFromUrl(modalData.url);
  }

  return getEmbedDataFromHtml(modalData.embed);
}

function getEmbedDataFromHtml(html) {
  if (!html) {
    return null;
  }

  return (0, _htmlToEmbedData.default)(html);
}

function getEmbedDataFromUrl(url) {
  var urlPattern = _embed.urlPatterns.find(function (pattern) {
    return pattern.regex.test(url);
  });

  if (!urlPattern) {
    return null;
  }

  var match = urlPattern.regex.exec(url);
  var src = urlPattern.url;
  /* eslint no-loop-func: 0 */

  var _loop = function _loop(i) {
    src = src.replace("$" + i, function () {
      return match[i];
    });
  };

  for (var i = 0; match[i]; i++) {
    _loop(i);
  }

  if (_embed.queryParamsDefaults[urlPattern.service]) {
    var queryParams = (0, _extends2.default)({}, _embed.queryParamsDefaults[urlPattern.service]);

    if (src.indexOf('?') >= 0 && src.length > src.indexOf('?') + 1) {
      var params = src.substring(src.indexOf('?') + 1).split('&');
      src = src.substring(0, src.indexOf('?'));

      for (var i = 0; params[i]; i++) {
        if (params[i].indexOf('=') >= 0) {
          var paramName = params[i].substring(0, params[i].indexOf('='));
          var paramValue = params[i].substring(params[i].indexOf('=') + 1);
          queryParams[paramName] = paramValue;
        }
      }
    }

    var queryString = Object.keys(queryParams).map(function (key) {
      return key + "=" + queryParams[key];
    }).join('&');
    src = src + "?" + queryString;
  }

  var data = {
    attributes: [{
      key: 'allowFullScreen',
      value: urlPattern.allowFullscreen
    }, {
      key: 'height',
      value: urlPattern.h
    }, {
      key: 'width',
      value: urlPattern.w
    }, {
      key: 'originalUrl',
      value: url
    }, {
      key: 'service',
      value: urlPattern.service
    }, {
      key: 'src',
      value: src
    }],
    tag: urlPattern.type
  };
  return [data];
} // Matches: ['https://', 'http://', '//'] and cannot contain whitespace


var EmbedUrlRegex = /^(?:http(?:s)?:)?\/\/[^\s/$.?#].[^\s]*$/; // Checks for valid opening and closing html tags:
// <tag ... /> || <tag>....</tag>

var EmbedHTMLRegex = /^<([a-zA-Z]+)[\w\W]+(?:\/>\s*)$|^<([a-zA-Z]+)[\w\W]+\/([a-zA-Z]+)(?:>\s*)$/; // Checks if the embed is a URL or an embed code

function getEmbedType(embed) {
  var urlMatch = EmbedUrlRegex.exec(embed);

  if (urlMatch) {
    return _embed.EmbedFormats.URL;
  }

  var embedMatch = EmbedHTMLRegex.exec(embed);

  if (embedMatch) {
    return _embed.EmbedFormats.EMBED;
  }

  return null;
}

function defaultValidateEmbed(_ref) {
  var url = _ref.url,
      embed = _ref.embed;

  if (url) {
    return EmbedUrlRegex.test(url);
  } else if (embed) {
    return EmbedHTMLRegex.test(embed);
  }

  return false;
}

function generateIframeEmbed(data) {
  var allowFullscreen = data.allowFullscreen ? 'allowFullscreen="1"' : '';
  return "<iframe class=\"hs-responsive-embed-iframe\" src=\"" + data.url + "\" width=\"" + data.width + "\" height=\"" + data.height + "\" " + allowFullscreen + " data-service=\"" + data.service + "\"></iframe>";
}

var matchesWhitelistedEmbedUrl = function matchesWhitelistedEmbedUrl(url) {
  if (!_embed.EXCLUSIVE_EMBED_URL_REGEX.test(url)) return false;
  return _embed.urlPatterns.find(function (pattern) {
    return pattern.regex.test(url);
  });
};

exports.matchesWhitelistedEmbedUrl = matchesWhitelistedEmbedUrl;

var convertUrlToEmbedData = function convertUrlToEmbedData(pastedUrl) {
  var match = matchesWhitelistedEmbedUrl(pastedUrl);
  return match && {
    url: pastedUrl
  };
};

exports.convertUrlToEmbedData = convertUrlToEmbedData;